import React, { Component } from "react";
import { Link } from "react-router-dom";
import MediaQuery from "components/MediaQuery";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import * as generalHelper from "lib/general-helper.js";
import { getRoleImg } from "lib/role_helper.js";
import { useQueryString } from "hooks/general-hooks";
import { getSpecialGameModeBuildPath } from "lib/specialGameMode";
import { useGlobal } from "reactn";

const ChampionLink = (props) => {
  const [language] = useGlobal("language");
  const { getChampionName, getNormalizedChampionName, getChampionImgFromSprite } = getRiotAssetsContext();

  const { championId, role, dim, location } = props;

  let params = useQueryString();

  // we've updated the role urls to compete on seo, so we need to separate role from
  // other params
  let roleUrl = generalHelper.getRoleUrl(role);
  params = generalHelper.buildQueryParams(params);
  const normalizedChampionName = getNormalizedChampionName(championId);

  let pathname =
    language !== "en_US"
      ? `/lol/${language.toLowerCase()}/champions/${normalizedChampionName}/build/${roleUrl}`
      : `/lol/champions/${normalizedChampionName}/build/${roleUrl}`;
  if (getSpecialGameModeBuildPath(location, normalizedChampionName)) {
    if (role !== "none") {
      params = Object.assign({}, generalHelper.parseQueryString(params), { role: generalHelper.getRevApiRole(role) });
      params = generalHelper.buildQueryParams(params);
    }
    pathname = getSpecialGameModeBuildPath(location, normalizedChampionName);
  }

  const kaynPathname = pathname.replace("/kayn/", "/red/kayn/");
  return (
    <Link
      className="champion-played gtm-tierlist-champion"
      to={{
        pathname: !championId === 141 ? pathname : kaynPathname,
        search: `?${params}`,
      }}
    >
      <div style={{ position: "relative" }}>
        <div className="champion-icon">{getChampionImgFromSprite(championId, { size: dim || 30 })}</div>
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
          {role !== "none" && (
            <div className="role" style={{ right: "-2px" }}>
              <img className="role-img" src={getRoleImg(role)} alt={role} />
            </div>
          )}
        </MediaQuery>
      </div>
      <strong className="champion-name">{getChampionName(championId)}</strong>
    </Link>
  );
};

export default ChampionLink;
